import { ToastService } from '@shared/toast';

import type { ToastId } from '@shared/toast';

/**
 * Affiche une erreur qui NE SE FERME PAS toute seule.
 *
 * BackStage affichait ses erreurs HTTP avec `autoClose: false` : elles restaient
 * jusqu'a ce que l'utilisateur les ecarte. Le `ToastService` du kit ne l'expose
 * pas directement — `resolveDuration` ne rend `'persistent'` que pour le type
 * `loading`, si bien qu'un `error` retombe toujours sur une duree finie.
 *
 * Plutot que de diverger du kit, on passe par sa propre mecanique : un toast
 * `loading` NAIT persistant, et `update()` conserve la duree existante des lors
 * que le nouveau type n'est pas `loading` (`patch.duration ?? existing.duration`).
 * Un `loading` immediatement bascule en `error` est donc un toast d'erreur
 * persistant, obtenu sans toucher a `app/shared/`.
 *
 * Verifie par test : `type=error`, `duration=persistent`, aucun minuteur arme.
 */
export function erreurPersistante(toast: ToastService, message: string, description?: string): ToastId {
  const id = toast.showLoading(message);
  toast.update(id, {
    type: 'error',
    message,
    ...(description !== undefined ? { description } : {}),
  });
  return id;
}
